/* eslint-disable prefer-arrow/prefer-arrow-functions */
export function joinNonEmptyStrings(values: (string | undefined)[], separator = ', ') {
  return values
    .map(value => (value == null ? value : value.trim()))
    .filter(Boolean)
    .join(separator);
}
